"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sport = exports.StatFormat = exports.onValidPlayCode = exports.isValidPlayCode = exports.MultiSportEventCode = void 0;
var MultiSportEventCode;
(function (MultiSportEventCode) {
    MultiSportEventCode["BeginPlay"] = "begin_play";
    MultiSportEventCode["EndPlay"] = "end_play";
    MultiSportEventCode["SetTeams"] = "set_teams";
    MultiSportEventCode["Play"] = "play";
    MultiSportEventCode["ActivatePlayer"] = "activate_player";
    MultiSportEventCode["DeactivatePlayer"] = "deactivate_player";
    MultiSportEventCode["EndPeriod"] = "end_period";
    MultiSportEventCode["AssignPlayer"] = "assign_player";
    MultiSportEventCode["AdjustScore"] = "adjust_score";
    MultiSportEventCode["OverrideScore"] = "override_score";
    MultiSportEventCode["SetGameSettings"] = "set_game_settings";
    // Volleyball
    MultiSportEventCode["SetServer"] = "set_server";
})(MultiSportEventCode = exports.MultiSportEventCode || (exports.MultiSportEventCode = {}));
function isValidPlayCode(playCode, codes) {
    return Object.values(codes).includes(playCode);
}
exports.isValidPlayCode = isValidPlayCode;
function onValidPlayCode(initialState, event, validPlayCodes, handler) {
    if (event.code !== MultiSportEventCode.Play) {
        return initialState;
    }
    var play = event;
    if (isValidPlayCode(play.attributes.play_code, validPlayCodes)) {
        return handler(initialState, play);
    }
    else {
        return initialState;
    }
}
exports.onValidPlayCode = onValidPlayCode;
var StatFormat;
(function (StatFormat) {
    StatFormat["INTEGER"] = "integer";
    StatFormat["DECIMAL"] = "decimal";
    StatFormat["FLOAT_PERCENTAGE"] = "floatPercentage";
    StatFormat["FLOAT_RATIO"] = "floatRatio";
    StatFormat["PERCENTAGE"] = "percentage";
    StatFormat["PERCENTAGE_SIGN"] = "percentageSign";
    StatFormat["WIDE_INTEGER"] = "wideInteger";
    StatFormat["JOIN"] = "join";
})(StatFormat = exports.StatFormat || (exports.StatFormat = {}));
var Sport;
(function (Sport) {
    Sport["SOCCER"] = "soccer";
    Sport["HOCKEY"] = "hockey";
    Sport["FIELD_HOCKEY"] = "fieldHockey";
    Sport["LACROSSE"] = "lacrosse";
    Sport["WATER_POLO"] = "waterPolo";
    Sport["RUGBY"] = "rugby";
    Sport["FOOTBALL"] = "football";
    Sport["FLAG_FOOTBALL"] = "flagFootball";
    Sport["BASKETBALL"] = "basketball";
    Sport["VOLLEYBALL"] = "volleyball";
})(Sport = exports.Sport || (exports.Sport = {}));
//# sourceMappingURL=definitions.js.map